import { useEffect, useState } from "react"
import { useEntidad, useManagedContext } from "../../components/hooks"
import { ServerRequest } from "../../utils/apiweb"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../config/apis"
import { SectionHeading, TableCustom } from "../../components/common"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"
import { getDateToString, getFormatNumber } from "../../utils/convert"

const DevolucionRendicionIngresosPublicosView = () => {
    const { setIsLoading, showMessageModal } = useManagedContext()

    const [lotes, setLotes] = useState([])
    const [selectedAll, setSelectedAll] = useState(false)

    useEffect(() => SearchDevolucionLotes(), [])

    const [, getRowEntidad ] = useEntidad({
        entidades: ['Recaudadora'],
        onLoaded: (_, isSuccess, error) => {
          if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
        },
        memo: {
          key: 'Recaudadora',
          timeout: 0
        }
    })

    const filterData = data => {
        let filtered = [...data]
        filtered.forEach((item, index) => {
            item.index = index
            item.selected = false
        })

        return filtered
    }
    const SearchDevolucionLotes = () => {
        setIsLoading(true)

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.DEVOLUCION_LOTE,
            '/ingresos-publicos',
            null,
            res => res.json().then(data => {
                data.sort((a,b) => a.idRecaudadora - b.idRecaudadora || a.idDevolucionLote - b.idDevolucionLote)
                setLotes(filterData(data))
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }
    const RendirIngresosPublicos = () => {

        setIsLoading(true)

        const dataBody = {
            idsDevolucionLote: lotes.filter(f => f.selected).map(x => x.idDevolucionLote)
        }

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.DEVOLUCION_LOTE,
            '/async/ingresos-publicos',
            dataBody,
            res => res.json().then(() => {
                ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, 'El proceso fue iniciado correctamente')
                SearchDevolucionLotes();
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const cellSelAll = (props) =>   <div className='action-check'>
                                        <input className='form-check-input' type="checkbox" value={''} checked={selectedAll}
                                            name="selectedAll"
                                            onChange={({target}) =>{
                                                const checked = target.checked
                                                setSelectedAll(checked)
                                                SelectAll(checked)
                                            }}
                                        />
                                    </div>
    const cellSel = (props) =>      <div className='action-check'>
                                        <input className='form-check-input' type="checkbox" value={''} checked={lotes[props.value].selected} readOnly={true} />
                                    </div>

    function SelectAll(checked) {
        const list = [...lotes]
        for (let index=0; index < list.length; index++) {
            if (list[index].rendicionIngresosPublicosSolicitada) continue
            list[index].selected = checked
        }
        setLotes(list)
    }
    function UnSelectAll() {
        setSelectedAll(false)
    }
    function UpdateItems(list) {
        UnSelectAll()
        setLotes(list)
    }

    const handleClickSelected = (index) => {
        const list = [...lotes]
        if (list[index].rendicionIngresosPublicosSolicitada) return
        list[index].selected = !list[index].selected
        UpdateItems(list)
    }
    const handleRendirIngresosPublicos = () => {
        if (lotes.filter(f => f.selected).length === 0) return ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe seleccionar un lote')

        showMessageModal({
            title: "Confirmación",
            message: "¿Está seguro/a de generar la rendición?",
            onConfirm: () => RendirIngresosPublicos(),
        })
    }

    return <>
        <SectionHeading titles={[{ title: 'Devoluciones' }, { title: 'Rendición a ingresos públicos' }]} />

        <section className='section-accordion'>

            <TableCustom
                className={'TableCustomBase'}
                data={lotes}
                columns={[
                    { Header: cellSelAll, Cell: cellSel, accessor: 'index', width:'3%', disableGlobalFilter: true, disableSortBy: true, ellipsis: false},
                    { Header: 'Recaudadora', accessor: 'idRecaudadora', width: '29%', Cell: ({ value }) =>  getRowEntidad('Recaudadora', value)?.nombre ?? '' },
                    { Header: 'N° lote devolución', accessor: 'numeroLote', width: '20%', Cell: ({ value, row }) => value + (row.original.rendicionIngresosPublicosSolicitada ? ' (Pendiente)' : '')},
                    { Header: 'Fecha lote', accessor: 'fechaLote', Cell: (data) => getDateToString(data.value), width: '8%'},
                    { Header: 'Casos', Cell: (data) => getFormatNumber(data.value, 0), accessor: 'casos', width: '10%', alignCell: 'right' },
                    { Header: 'Casos conciliados', Cell: (data) => getFormatNumber(data.value, 0), accessor: 'casosConciliados', width: '10%', alignCell: 'right' },
                    { Header: 'Devolución', Cell: (data) => getFormatNumber(data.value, 2), accessor: 'importeTotal', width: '20%', alignCell: 'right' },
                ]}
                showDownloadCSV={false}
                showFilterGlobal={false}
                onClickRow={(row, cellId) => {
                    handleClickSelected(row.index);
                }}
                getRowClassName={(row) => row.rendicionIngresosPublicosSolicitada ? 'rt-tr-anulado' : ''}
            />

        </section>

        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <button className="btn action-button float-end" onClick={ (event) => handleRendirIngresosPublicos() }>Confirmar</button>
            </div>
        </footer>

    </>
}

export default DevolucionRendicionIngresosPublicosView
